module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-ExtraBoldItalic.woff?027e59f6bef443d7db0cbb290126125d";